import helmet from '../assets/helmet.png'

const employeeSchema = {
    firstName: 'John',
    lastName: 'Wick',
    position: 'Position',
    phone: '7584215648',
    email: 'abc@xyz.com',
    address: 'Address',
    anniversary: '15 January',
    dob: '23-04-1990',
    trainingReview: [],
    rewards: [],
    shiftPreference: '',
    timeOffSchedules: '',
    trainings: {
        onBoardingTraining: [],
        onGoingTraining: [],
        trainingRequests: [],
        advancedTraining: [],
        completedTraining: []
    },
    equipmentReservations: []
}

const positionHistorySchema = {
    name: 'Jade',
    joiningDate: '20-05-2018',
    leavingDate: '30-07-2022'
}

const positionSchema = {
    department: 'Service',
    role: 'Technician',
    vacancyDate: '01-08-2022',
    postingLink: 'https://jobsearch.com/technician',
    approvers: ['ABC', 'CEO'],
    positionHistory: [positionHistorySchema, positionHistorySchema],
    vacancyReason: 'Employee got another job'
}


const mobileVansSchema = {
    make: 'Tesla',
    model: 'S',
    registrationDate: '20-02-2022',
    maintainenceSchedule: '15-09-22',
    age: '7',
    insurance: '20-02-2023',
    incidence: 'Breakdown on 06-08-2022',
    assignedTo: 'Technician 1'
}

const specialEquipmentSchema = {
    equipment: 'Equipment 1',
    inStock: '10',
    assigned: '5',
    location: 'Loc 1'
}

const softwareUpdateSchema = {
    manufacturer: 'Tesla',
    patchReleaseOn: '08-09-2024',
    patchType: 'New Feature',
    countOfApplications: '5'
}

const upcomingReservationsSchema = {
    reservedBy: 'Technician 1',
    reservationDate: '16-09-2022',
    location: 'Toronto'
}

const equipmentSchema = {
    name: 'Class 1 Arc Flash Helmet',
    imageUrl: helmet,
    inStock: '5',
    checkinTime: '05-09-2022, 08:00 AM',
    checkoutTime: '05-09-2022, 12:00 PM',
    location: 'Toronto',
    upcomingReservations: [upcomingReservationsSchema, upcomingReservationsSchema, upcomingReservationsSchema]
}

const upcomingAppointmentSchema = {
    appointmentDate: 'Appointment Name',
    appointmentType: 'Appointment Type'
}

const resourceAppointmentSchema = {
    resourceName: 'Resource Name',
    appointmentDate: 'Appointment Date',
    appointmentType: 'Appointment Type'
}

const resourceAvailabilitySchema = {
    scheduledAssociates: 'ABC',
    approvedPtoRequests: 'DEF',
    onCallResources: 'XYZ',
    sickCalls: 'KLM'
}

const resourceRequirementSchema = {
    upcomingAppointments: '15-09-2022',
    roadsideAssistanceEstimates: 'XYZ',
    specialEquipmentRequest: 'Gloves',
    specialTrainingRequirement: 'Battery leakage'
}

const resourceDeficiencySchema = {
    upcomingAppointments: '15-09-2022, 08:00 pm',
    resourceAssigned: 'Technician B',
    locationOfAppointment: 'Ontario',
    onCallResourceAssigned: 'Resource 2'
}

const workOrderSchema = {
    workOrderNo: 'ORD10098',
    invoiceAmount: '$1500',
    date: '15-08-2022',
    time: '11:00 am',
    typeOfService: 'Vinyl Wrap',
    description: 'PVC Coating',
    status: 'Upcoming'
}


const commentSchema = {
    date: '',
    comment: ''
}


const customerSchema = {
    name: 'Abc',
    phone: '9452154865',
    email: 'abc@xyz.com',
    address: 'Ontario, Canada',
    vehicleProfile: 'Tesla S',
    paymentMethod: 'Credit Card',
    notificationPreference: 'Upcoming Appointments Only',
    workOrders: {
        softwareUpgrades: [workOrderSchema],
        physicalRepairs: [workOrderSchema],
        upgradeAndCustomizations: [workOrderSchema],
        roadsideAssists: [workOrderSchema],
        cancelledRequests: [workOrderSchema]
    },
    workSatisfactionSurvey: {
        priorRating: '',
        priorComments: [commentSchema]
    }
}


const billingInvoiceSchema = {
    number: 'INV009878',
    date: '08-08-22',
    amount: '$1000',
    customerName: 'ABC',
    servicerName: 'Technician A',
    status: 'Paid'
}

const operatingCostSchema = {
    scheduledResource: 'Technician',
    scheduledDuration: '5 hr',
    workOrderValue: '$1100',
    resourceCostPerHour: '$50'
}

const appointmentSchema = {
    date: '15-09-2022',
    serviceType: 'Battery Replacement',
    serviceName: 'Technician 2',
    jobOrderNo: 'OR00987676',
    estimate: '$1500',
    status: 'Upcoming'
}

const paymentSchema = {
    serviceType: 'Tyre',
    date: '15-09-2022',
    jobOrderNo: 'ORD09878787',
    paymentStatus: 'Done'
}



const finance = {
    operatingCost: [operatingCostSchema],
    appointments: [appointmentSchema],
    payments: [paymentSchema]
}

const billing = {
    paidInvoices: [billingInvoiceSchema],
    outstandingInvoices: [billingInvoiceSchema],
    upcomingWorkOrders: [workOrderSchema]
}

const customer = {
    list: [customerSchema],
    
}

const shifts = {
    resourceAvailability: [resourceAvailabilitySchema],
    resourceRequirements: [resourceRequirementSchema],
    resourceDeficiency: [resourceDeficiencySchema]
}

const appointments = {
    currentLocationAppointments: [upcomingAppointmentSchema],
    resourceWiseAppointments: [resourceAppointmentSchema],
}

const specialEquipments = {
    list: [equipmentSchema]
}

const equipmentTransferSchema = {
    itemName: 'Helmet',
    quantity: 2,
    transferTo: 'Warehouse 1 Zone 2'
}

const transferListSchema = {
    transferDate: '17-10-2022 03:45 AM',
    from: 'Warehouse Zone 1',
    to: 'Warehouse Zone 2',
    type: 'Warehouse Transfer'
}

const inventory = {
    mobileVans: [mobileVansSchema],
    mobileWorkshop: {
        chargers: '',
        specialEquipments: [specialEquipmentSchema]
    },
    softwareUpdates: [softwareUpdateSchema]
}

const employee = {
    ceo: 'ABC',
    list: {
        sales: {
            manager: 'Jack',
            employees: [employeeSchema]
        },
        service: {
            manager: 'John',
            employees: [employeeSchema]
        },
        office: {
            manager: 'Sam',
            employees: [employeeSchema]
        },
        marketing: {
            manager: 'Reynold',
            employees: [employeeSchema]
        }
    },
    openPositions: {
        technician: [positionSchema],
        admin: [positionSchema],
        marketingExecutive: [positionSchema]
    }
}

const searchVehicleFormData = {
    make: "",
    year: "",
    model: "",
    vin: "",
    submodel: "",
    engine: "",
  };

export { 
        finance,
        billing, 
        customer, 
        shifts, 
        appointments, 
        specialEquipments, 
        inventory, 
        employee, 
        positionSchema, 
        equipmentSchema, 
        workOrderSchema, 
        equipmentTransferSchema,
        transferListSchema,
        searchVehicleFormData
    }